// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WBSm","type":"styles_type__2dkyh","choices":"styles_choices__1joKw"};